const cdn = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

const showcaseImages = {
  nuxt: cdn("photo-1521737604893-d14cc237f11d"),
  quiz: cdn("photo-1587614382346-4ec70e388b28"),
  weather: cdn("photo-1501854140801-50d01698950b"),
  menu: cdn("photo-1517245386807-bb43f82c33c4"),
  recipe: cdn("photo-1504674900247-0877df9cc836"),
  chat: cdn("photo-1556157382-97eda2d62296"),
  tour: cdn("photo-1500530855697-b586d89ba3ee"),
  travel: cdn("photo-1507525428034-b723cf961d3e"),
  spacex: cdn("photo-1446776811953-b23d57bd21aa"),
  movie: cdn("photo-1524985069026-dd778a71c7b4"),
  snippet: cdn("photo-1525182008055-f88b95ff7980"),
  github: cdn("photo-1545239351-1141bd82e8a6"),
  covid: cdn("photo-1582719478250-c89cae4dc85b"),
  ecommerce: cdn("photo-1486427944299-d1955d23e34d"),
  expense: cdn("photo-1483478550801-ceba5fe50e8e"),
  weatherApp: cdn("photo-1504384308090-c894fdcc538d"),
  grocery: cdn("photo-1506806732259-39c2d0268443"),
  mobileWallet: cdn("photo-1512428559087-560fa5ceab42"),
  fitnessTracker: cdn("photo-1504384308090-c894fdcc538d"),
  keeper: cdn("photo-1515879218367-8466d910aaa4"),
};

export const data = [
  {
    link: "https://keeper123.netlify.app/",
    img: showcaseImages.keeper,
    name: "Keeper",
    description:
      "Organization-based multi-tenant boards with admin-only creation, member-specific access, and secure collaboration. Built with React, Redux Toolkit + RTK Query, Express, Prisma, Postgres, and Docker; deployed on Render.",
    category: "React, Redux Toolkit, RTK Query, Express, Prisma, Postgres",
  },
  {
    link: "https://github.com/juac08/AwesomeStorybook",
    img: showcaseImages.mobileWallet,
    name: "Nordlys Design System for React Native",
    description:
      "Built and productionized a reusable React Native design system with strict TypeScript APIs, accessibility-first defaults, unified form/error states, and ActionSheet-based Select UX. Ships with one production-ready default theme and supports validated custom theming.",
    category: "React Native, TypeScript, Design System",
  },
  {
    link: "https://github.com/juac08/AwesomeStorybook",
    img: showcaseImages.fitnessTracker,
    name: "Design System Test App (Expo)",
    description:
      "Comprehensive Expo validation app for real user flows: forms, selects, transaction lists, toasts, modals, and accessibility checks. Used to verify theming behavior, interaction edge cases, and release quality before publishing design-system updates.",
    category: "React Native, Expo, QA",
  },
  {
    video: "/images/flow.mp4",
    img: showcaseImages.mobileWallet,
    name: "React Native Expense Tracker",
    description:
      "React Native expense tracker built with Expo and the Expo SQLite plugin, featuring local-only storage (no auth), category budgets, quick add, filters, and summary insights.",
    category: "React Native, Expo, SQLite",
  },
  {
    link: "https://nuxt-task-manager.netlify.app",
    img: showcaseImages.nuxt,
    name: "Nuxt App Desktop Version",
    description:
      "Nuxt-powered task manager with Pinia state, desktop-first UX, and live filters. Built with Nuxt 4, Vue 3, and Pinia for a type-safe, modular store that stays out of the way.",
    category: "Nuxt 4, Vue 3, Pinia",
  },
  {
    link: "https://junaid-quiz-app.netlify.app/",
    img: showcaseImages.quiz,
    name: "Quiz App",
    description:
      "Quiz app in React with a wide range of categories, difficulty levels, and configurable question count. Includes score tracking and API-sourced questions.",
    category: "React",
  },
  {
    link: "https://luminous-florentine-5f403c.netlify.app/",
    img: showcaseImages.weather,
    name: "Weather Dashboard",
    description:
      "Weather dashboard app using Vue.js with Pinia for state management and API integration.",
    category: "React, Firebase",
  },
  {
    link: "https://menu123.netlify.app",
    img: showcaseImages.menu,
    name: "Restaurant Menu",
    description:
      "Restaurant menu app in React with category filters and dynamic item rendering.",
    category: "React",
  },
  {
    link: "https://junaid-simple-recipes.netlify.app/",
    img: showcaseImages.recipe,
    name: "Simple Recipe",
    description:
      "Static recipe explorer on Gatsby with Contentful and GraphQL data layer.",
    category: "gatsby",
  },
  {
    link: "https://advance-scss.netlify.app/",
    img: showcaseImages.tour,
    name: "Tour App",
    description:
      "Landing page built with semantic HTML, Flexbox layouts, and advanced Sass.",
    category: "HTML/SCSS",
  },
  {
    link: "https://backdoor-tours.netlify.app/",
    img: showcaseImages.travel,
    name: "BackDoor Tours",
    description:
      "Travel brand site using React with Styled Components and responsive Flexbox.",
    category: "React,Styled Component",
  },
  {
    link: "https://junaid-space-x.netlify.app/",
    img: showcaseImages.spacex,
    name: "SpaceX",
    description:
      "SpaceX launch explorer built in React with GraphQL queries and charts.",
    category: "Mern Stack",
  },
  {
    link: "https://jmdb0808.netlify.app/",
    img: showcaseImages.movie,
    name: "Movie DB",
    description:
      "Movie discovery UI using React, OMDB API search, and watchlist state.",
    category: "React",
  },
  {
    link: "https://junaid-snippet-manager.netlify.app/",
    img: showcaseImages.snippet,
    name: "Snippet Manager",
    description:
      "MERN stack snippet vault with JWT auth and secure CRUD for saved code.",
    category: "Mern Stack",
  },
  {
    link: "https://junaid-githubsearch.netlify.app",
    img: showcaseImages.github,
    name: "GitHub User Search",
    description:
      "GitHub user insights app: React + Auth0 login and Fusion Charts visualizations.",
    category: "React",
  },
  {
    link: "https://expense-tracker0808.netlify.app",
    img: showcaseImages.expense,
    name: "Expense Tracker",
    description:
      "Expense tracker in React with category breakdowns and ChartJS summaries.",
    category: "React",
  },
  {
    link: "https://weather-0808.netlify.app",
    img: showcaseImages.weatherApp,
    name: "Weather Aplication",
    description:
      "Weather dashboard consuming OpenWeather API with search and saved cities.",
    category: "React",
  },
  {
    link: "https://grocery-items123.netlify.app/",
    img: showcaseImages.grocery,
    name: "Grocery Bud",
    description:
      "Grocery list app using React hooks for add/edit, persistence, and filters.",
    category: "React",
  },
];
